<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-100 py-6">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <img class="bg-auth-circle-shape" src="../../assets/img/illustrations/bg-shape.png" alt="" width="250">
        <img class="bg-auth-circle-shape-2" src="../../assets/img/illustrations/shape-1.png" alt="" width="150">
        <div class="card" *ngIf="tokenValid">
          <div class="card-body p-4 p-sm-5">
            <h5 class="text-center">Reset new password</h5>
            <form class="mt-3" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <input class="form-control" type="password" placeholder="New Password" formControlName="password" [ngClass]="{'is-invalid': submitted && resetPasswordFormControl.password.errors }" />
                <div *ngIf="submitted && resetPasswordFormControl.password.errors" class="invalid-feedback">
                  <div class="text-left" *ngIf="resetPasswordFormControl.password.errors.required">Password is required</div>
                </div>
                <div class="text-danger" *ngIf="resetPasswordFormControl.password.value && resetPasswordFormControl.password.value.length<6">
                  Password is required 6 characters minimum
                </div>
              </div>
              <div class="form-group">
                <input class="form-control" type="password" placeholder="Confirm Password" formControlName="confirmPassword" [ngClass]="{'is-invalid': submitted && resetPasswordFormControl.confirmPassword.errors }" />
                <div *ngIf="submitted && resetPasswordFormControl.confirmPassword.errors" class="invalid-feedback">
                  <div class="text-left" *ngIf="resetPasswordFormControl.confirmPassword.errors.required">Confirm Password is required</div>
                </div>
                <div class="text-left text-danger" *ngIf="!resetPasswordForm.invalid && resetPasswordFormControl.password.value!=resetPasswordFormControl.confirmPassword.value">Passwords do not match</div>
              </div>
              <button class="btn btn-primary btn-block mt-3" [disabled]="resetPasswordFormControl.password.value.length<6">Set password</button>
            </form>
          </div>
        </div>
        <div class="card" *ngIf="!tokenValid">
          <div class="card-body p-4 p-sm-5">
            <div class="text-center">
              <h4>Token is unavailable!</h4>
              <a class="btn btn-primary btn-sm mt-3" [routerLink]="'/login'"><span class="fas fa-chevron-left mr-1" data-fa-transform="shrink-4 down-1"></span>Return to login</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
